import { render, staticRenderFns } from "./CeurList.vue?vue&type=template&id=15203bac"
import script from "./CeurList.vue?vue&type=script&lang=js"
export * from "./CeurList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports